import {useEffect, useState} from 'react';
import {
  isMobile as isMobileUtil,
  isLandscape as isLandscapeUtil,
  isPortrait as isPortraitUtil,
} from '../utils/miscUtils';

export const useDevice = () => {
  const [isLandscape, setIsLandscape] = useState(isLandscapeUtil);
  const [isMobile, setIsMobile] = useState(isMobileUtil);
  const [isPortrait, setIsPortrait] = useState(isPortraitUtil);

  useEffect(() => {
    const listener = () => {
      setIsLandscape(isLandscapeUtil);
      setIsMobile(isMobileUtil);
      setIsPortrait(isPortraitUtil);
    };
    window.addEventListener('orientationchange', listener);
    return () => {
      window.removeEventListener('orientationchange', listener);
    };
  }, []);

  return {isLandscape, isMobile, isPortrait};
}; 
